module.exports = __webpack_public_path__ + "static/media/icon.0384995f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon.png
// module id = 310
// module chunks = 0